export const internalSelectionMenuInjectionKey = Symbol('internal-select-menu');
export const internalSelectionMenuBodyInjectionKey = Symbol('internal-select-menu-body');
